import React from "react"
import { StaticQuery, graphql } from "gatsby"

import TeamMember from "./../../components/TeamMember"

import { Container, Title, List } from "./styles.js"

class Team extends React.Component {
  render() {
    return (
      <Container>
        <Title>{this.props.name}</Title>
        <List>
          {this.props.members.map(
            ({
              member: {
                document: [{ id, data }],
              },
            }) => {
              return <TeamMember key={id} {...data} />
            }
          )}
        </List>
      </Container>
    )
  }
}

export default Team
